export class ItemContratoPeca {
  constructor({
    tipoInstrumentoId,
    modeloInstrumentoId,
    itemId,
    percentualDesconto = 0,
    itemDescricao,
    itemCodigo,
    tipoInstrumentoNome,
    modeloInstrumentoNome,
    itemValor,
  }) {
    this.tipoInstrumentoId = tipoInstrumentoId;
    this.modeloInstrumentoId = modeloInstrumentoId;
    this.itemId = itemId;
    this.id = itemId;
    this.percentualDesconto = percentualDesconto;
    this.itemDescricao = itemDescricao;
    this.itemCodigo = itemCodigo;
    this.tipoInstrumentoNome = tipoInstrumentoNome;
    this.modeloInstrumentoNome = modeloInstrumentoNome;
    this.valorVenda = itemValor;
    this.valorVendaComDesconto = itemValor;
  }
}